export default "__VITE_ASSET__DCtJcjqx__"